export default __webpack_public_path__ + "static/media/Alloisio e lupus.80d98e3b.jpg";